import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { db } from '../services/firebase'
import { doc, getDoc } from 'firebase/firestore'
import { getSession } from '../services/auth'
import Signature from '../components/Signature'

/**
 * tingl.me/u/:username — a personal doorway into the protocol.
 * Anyone who opens it can knock on this person with one tap.
 * If they're not on tingl yet, signup auto-knocks for them.
 */
export default function KnockLanding() {
  const { username } = useParams()
  const nav = useNavigate()
  const [exists, setExists] = useState<boolean | null>(null)
  const [realName, setRealName] = useState('')
  const [cycle, setCycle] = useState(0)

  useEffect(() => {
    if (!username) { setExists(false); return }
    getDoc(doc(db, 'usernames', username.toLowerCase()))
      .then((snap) => {
        if (snap.exists()) {
          setExists(true)
          setRealName((snap.data() as any).username || username)
        } else setExists(false)
      })
      .catch(() => setExists(false))
  }, [username])

  // loop the knock signature softly in the background
  useEffect(() => {
    const id = setInterval(() => setCycle((c) => c + 1), 3200)
    return () => clearInterval(id)
  }, [])

  const go = () => {
    if (getSession()) {
      // already a tingler — go home with knock intent
      nav(`/home?knock=${encodeURIComponent(realName)}`)
    } else {
      nav(`/signup?knock=${encodeURIComponent(realName)}`)
    }
  }

  if (exists === null) {
    return <div className="screen screen-center"><div className="logo-dot" style={{ width: 12, height: 12 }} /></div>
  }

  if (!exists) {
    return (
      <div className="screen screen-center">
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🫧</div>
          <div style={{ color: 'var(--text-dim)', marginBottom: 24 }}>No one by that name in the protocol.</div>
          <button className="pill grad" style={{ maxWidth: 240 }} onClick={() => nav('/')}>Explore tingl →</button>
        </div>
      </div>
    )
  }

  return (
    <div className="screen screen-center">
      {/* soft knock signature ambience */}
      <div style={{ position: 'absolute', inset: 0, opacity: 0.5, pointerEvents: 'none' }}>
        <Signature key={cycle} vibeKey="KNOCK" color="#00FFD1" duration={3000} fpsCap={24} />
      </div>

      <div className="fade-in" style={{ width: '100%', maxWidth: 380, textAlign: 'center', position: 'relative', zIndex: 2 }}>
        <div className="logo" style={{ fontSize: 38, justifyContent: 'center' }}>
          <span className="t">t</span><span className="ingl">ingl</span>
          <span className="logo-dot" style={{ width: 7, height: 7, marginBottom: 27, marginLeft: -18 }} />
        </div>

        <div style={{ margin: '34px 0' }}>
          <div className="eyebrow" style={{ marginBottom: 10 }}>you've been invited to knock on</div>
          <div className="syne" style={{
            fontWeight: 800, fontSize: 'clamp(28px, 8vw, 38px)', letterSpacing: '-0.03em',
            background: 'linear-gradient(135deg, #00FFD1, #00C8FF)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          }}>
            {realName}
          </div>
          <div style={{ fontSize: 14, color: 'var(--text-dim)', lineHeight: 1.6, maxWidth: 290, margin: '16px auto 0' }}>
            tingl sends feelings — not texts. One second of light, motion & touch, from one human to another.
          </div>
        </div>

        <button className="pill grad" style={{ maxWidth: 300 }} onClick={go}>
          ✦ Knock on {realName}
        </button>
        <div style={{ fontSize: 11.5, color: 'var(--text-faint)', marginTop: 14 }}>
          free · no email needed · takes 20 seconds
        </div>
      </div>
    </div>
  )
}
